<template>
  <v-app>
    <router-view v-if="fullLayout"></router-view>
    <dashboard v-else />

    <!-- Errors Notification -->
    <errors-notification id="errors-notification" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DashboardVue from './views/dashboard/Dashboard.vue'
import errorsNotificationVue from './views/_partials/AppErrorsNotification.vue'

export default {
  name: 'App',
  components: {
    dashboard: DashboardVue,
    errorsNotification: errorsNotificationVue
  },

  data() {
    return {
      fullLayout: false,
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        { icon: 'fa-receipt', title: 'Home' },
        { icon: 'fa-barcode', title: 'Dashboard' },
        { icon: 'fa-shopping-basket', title: 'Inventory' },
        { icon: 'fa-dolly', title: 'Store' },
        { icon: 'fa-tags', title: 'promotions' },
        { icon: 'fa-truck-loading', title: 'Customers' }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'KEENTECH',
      ttDirectionSidebar: 'left',
      isMounted: false
    }
  },

  mounted() {
    this.setLocale()
  },

  computed: {
    ...mapGetters({
      locales: 'locale/getLocales',
      authUserData: 'auth/getAuthUserData',
      getResetValidationErrors: 'errors/getResetValidationErrors'
    })
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        // check if the current page is the homepage or the login page
        // in order to render special layout without sidebar and topbar
        let url = this.$route.path.toLowerCase()
        this.fullLayout = !!(url === '/' || url.indexOf('/login') === 0)
      }
    },

    getResetValidationErrors: {
      immediate: true,
      handler() {
        this.resetVeeErrors()
        this.resetAllErrors(false)
      }
    },

    authUserData: {
      immediate: true,
      handler() {
        // checking for user login
        let authData = this.authUserData
        if (authData.constructor === Object && Object.keys(authData).length !== 0) {
          this.fetchSystemSettings()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      fetchSystemSettings: 'configurations/fetchSystemSettings',
      changeLocales: 'locale/changeLocales',
      setRtl: 'locale/setRtl',
      setCountriesList: 'locale/setCountriesList',
      resetAllErrors: 'errors/resetAllErrors'
    }),

    setLocale() {
      // get language stored in the localstorage, if null then fallback to english
      // then filter the locales array to get the matching language
      let lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en'
      let direction = this.locales.filter(l => l.value === lang)[0]
      let isRtl = false

      // Just in case after filtering the locales array didn't return any match,
      // i.e some rubbish or unsupported language was given, fall back to english
      // else get the direction of the matched locale
      if (!direction) {
        lang = 'en'
      } else {
        isRtl = !!(direction.dir === 'rtl')
      }

      // then set locale and direction accordingly
      this.$vuetify.rtl = isRtl
      this.$i18n.locale = lang
      this.changeLocales(lang)
      this.setCountriesList(lang)
      this.setRtl(isRtl)
    },

    resetVeeErrors() {
      this.$validator.pause()
      this.$nextTick(() => {
        for (let i = 0, ln = this.errors.items.length; i < ln; i++) {
          this.errors.items.pop()
        }
        this.$validator.resume()
      })
    }
  }
}
</script>

<style scoped>
#errors-notification {
  z-index: 1000000;
}
</style>
